/**
 * Constrói a URL completa para imagens
 * Em produção, usa o mesmo domínio ou variável de ambiente
 * Em desenvolvimento, usa localhost:5000
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // Se já é uma URL completa, retorna como está
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Em produção
  if (process.env.NODE_ENV === 'production') {
    // Se há variável de ambiente para API URL, usar ela
    const apiUrl = process.env.REACT_APP_API_URL;
    if (apiUrl) {
      // Remover /api do final se presente e construir URL
      const baseUrl = apiUrl.replace(/\/api\/?$/, '');
      // Garantir que a URL não tenha barra dupla
      const cleanPath = imagePath.startsWith('/') ? imagePath : '/' + imagePath;
      return `${baseUrl}${cleanPath}`;
    }
    
    // Se não há REACT_APP_API_URL, as imagens podem estar em /api/uploads/ ou /uploads/
    // Dependendo da configuração do servidor
    // Por padrão, tentar com /api primeiro se o caminho começa com /uploads/
    if (imagePath.startsWith('/uploads/')) {
      // Em produção, as imagens geralmente são servidas via API
      // Então /uploads/img.jpg deve ser /api/uploads/img.jpg
      // Mas também pode ser servido diretamente pelo servidor web em /uploads/
      // Tentar primeiro com /api, se não funcionar, ajustar no servidor
      return `/api${imagePath}`;
    }
    
    // Caso contrário, usar o mesmo domínio (imagens na mesma origem)
    // Se a imagem já começa com /, usar direto, senão adicionar /
    return imagePath.startsWith('/') ? imagePath : '/' + imagePath;
  }
  
  // Em desenvolvimento, usar localhost:5000
  return `http://localhost:5000${imagePath}`;
};

